import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { Anomaly } from 'shell/view-models/anomaly';

interface Response {
  key: {
    codice: string;
  };
  descrizione: string;
  flagAnomalia: string;
}

interface AnomaliesListProps {
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  value: string;
  label: string;
  onChange: (anomaly: Anomaly | undefined) => void;
}

const AnomaliesListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label,
  required,
}: AnomaliesListProps): React.ReactElement => {
  const [options] = useHttpFetch<HttpResponseListPayloadQuarkus<Response>, Array<Anomaly>>(
    `${__PERSON_NEW_API_URL__}/persona/tipo-anomalie`,
    {
      onBootstrap: true,
      initialData: [],
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response) =>
        (response?.data?.payload || []).map((option) => ({
          code: option.key?.codice,
          description: option.descrizione,
          flag: option.flagAnomalia,
        })),
    }
  );
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="anomalies-list">
        {required ? `${label} *` : `${label}`}
      </InputLabel>
      <PmiSelect
        labelId="anomalies-list"
        id="anomalyCode"
        name="anomalyCode"
        value={value}
        label={required ? `${label} *` : `${label}`}
        onChange={(event) => {
          const anomaly = (options.data as Array<Anomaly>).find(
            (element) => element.code === event.target.value
          );
          onChange(anomaly);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuna</em>
        </MenuItem>
        {((options.data as Array<Anomaly>) || []).map((option: Anomaly) => (
          <MenuItem key={option.code} value={option.code}>
            {`${option.code} - ${option.description}`}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

AnomaliesListComponent.displayName = 'List code anomaly component';

const AnomaliesList = memo(AnomaliesListComponent);

export default AnomaliesList as typeof AnomaliesListComponent;
